export default __webpack_public_path__ + "static/media/icon-eth.4f0963ea.svg";